// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 139,
  argument: "A prayer to be delivered from the wicked.",
  verses: [
    { n: 1, text: "Unto the end, a psalm for David." },
    { n: 2, text: "Deliver me, O Lord, from the evil man: rescue me from the unjust man." },
    { n: 3, text: "Who have devised iniquities in their hearts: all the day long they designed battles." },
    { n: 4, text: "They have sharpened their tongues like a serpent: the venom of asps is under their lips." },
    { n: 5, text: "Keep me, O Lord, from the hand of the wicked: and from unjust men deliver me. Who have proposed to supplant my steps: 6 the proud have hidden a net for me. And they have stretched out cords for a snare: they have laid for me a stumbling-block by the wayside." },
    { n: 7, text: "I said to the Lord: Thou art my God: hear, O Lord, the voice of my supplication." },
    { n: 8, text: "O Lord, Lord, the strength of my salvation: thou hast overshadowed my head in the day of battle." },
    { n: 9, text: "Give me not up, O Lord, from my desire to the wicked: they have plotted against me: do not thou forsake me, lest they should triumph." },
    { n: 10, text: "The head of their compassing me about: the labour of their lips shall overwhelm them." },
    { n: 11, text: "Burning coals shall fall upon them; thou wilt cast them down into the fire: in miseries they shall not be able to stand." },
    { n: 12, text: "A man full of tongue shall not be established in the earth: evils shall catch the unjust man unto destruction." },
    { n: 13, text: "I know that the Lord will do justice to the needy, and will revenge the poor." },
    { n: 14, text: "But as for the just, they shall give glory to thy name: and the upright shall dwell with thy countenance." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "David. He, (Calmet) Ezechias, (Ven. Bede) the captives, (Bossuet) or Jesus Christ and his servants under persecution, speak in this psalm. (Holy Fathers) See Psalm lv.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "Man. Saul, (Calmet) Judas, (St. Hilary) or self-love, the old man, who is our most dangerous enemy.", attribution: "Berthier" }
    ] },
    { verse: 3, notes: [
      { text: "Battles. And formed plots to destroy the just.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "Serpent. So Plautus says, \"A double-tongued and wicked man is like a creeping beast,\" in Persa.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Side. The enemies of David calumniated him, and strove to make him follow idols, 1 Kings xxvi. 19.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Battle. Against Goliath, or against the attempts of Saul, &c. (Calmet) — Prayer and divine grace are necessary, to guard us from sin.", attribution: "Worthington" }
    ] },
    { verse: 9, notes: [
      { text: "Desire. If I yield to my passions, (St. Augustine) or after I have expressed my request, contrary to my desire, &c. Hebrew, \"Grant not the desire of the sinner, complete not his thought. They will be elated.\" Some supply, \"lest they be.\" The ancients seem not to have read in the same manner. (Berthier) — Abandon not my soul, which is all my care, (Psalm xxi. 21.) to the sinner.", attribution: "Calmet" }
    ] },
    { verse: 10, notes: [
      { text: "Head. Hebrew also, \"poison,\" (Berthier) or \"sum\" of their mischievous devices. (Worthington) — Labour, or punishment. (Calmet) — Their subtle persuasions shall turn to their ruin.", attribution: "Worthington" }
    ] },
    { verse: 11, notes: [
      { text: "Fire of hell, (Worthington; Chaldean) as well as temporal afflictions, from lightning, &c., Psalm xvii. 9. (Haydock) — Some have ridiculed the belief of hell. But the universality of this opinion is a strong proof of it, as it is also confirmed by revelation.", attribution: "Berthier" }
    ] },
    { verse: 12, notes: [
      { text: "Tongue. This member is very dangerous. (Pet. Bless. cxix.) (James iii. 6.) — The just man is not styled \"a man of tongue,\" but \"of heart;\" for which reason Christ exhorted his disciples not to make long speeches in prayer, Matthew vi. 7. (Berthier) — Into. Literally, \"in;\" though (Haydock) it should be into, conformably to the Septuagint. (Berthier) Raro antecedentem scelestum Deseruit pede pœna claudo.", attribution: "Horace, iii. Od. ii." }
    ] },
    { verse: 13, notes: [
      { text: "I know. Hebrew, \"thou knowest.\" But some copies read more accurately. (Houbigant) — Poor. Thus, in the end, was Lazarus treated. [Luke xvi. 22.]", attribution: "Worthington" }
    ] },
    { verse: 14, notes: [
      { text: "Countenance in glory, when thou shalt appear, 1 John iii. 2. (Haydock) — They shall dwell under thy special protection in the tabernacle.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
